<template>
  <!-- <v-dialog
    v-model="dialog"
    max-width="300"
  >
    <v-card>
      <v-card-title class="pb-0">
        Add a Quicklink
        <v-spacer></v-spacer>
        <v-btn
          icon
          @click="dialog = false"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pt-2">
        <b-alert v-model="hasError" variant="danger" fade>
          {{ errorMessage }}
        </b-alert>
        <b-alert v-model="success" variant="success" fade>
          {{ successMessage }}
        </b-alert>
        <div class="accordion-box-quicklinks" v-if="quicklinks.length > 0">
          <div v-b-toggle.collapse-1>Current Quicklinks <i class="fas fa-chevron-down"></i></div>
          <b-collapse id="collapse-1">
            <div class="collapse-container pt-2">
              <div v-if="quicklinks.length">
                <div v-for="link in quicklinks" :key="link.field_001">
                  <div><small>{{link.name}} ({{link.url}})</small><i class="fas fa-times removeQuicklink" @click="removeQuicklink(link.field_001)"></i></div>
                </div>
              </div>
              <div v-else>
                <small>No Quicklinks yet</small>
              </div>
            </div>
          </b-collapse>
        </div>

        <form @submit.prevent="onSubmit">
          <dx-text-box
            name="name"
            label-mode="floating"
            label="Name"
            v-model="form.name"
            class="mt-3"
          >
            <dx-validator>
              <dx-validation-rule type="required" />
            </dx-validator>
          </dx-text-box>
          <dx-text-box
            label-mode="floating"
            label="URL (e.g. https://venturelab.swiss)"
            v-model="form.url"
            class="mt-3"
          >
            <dx-validator>
              <dx-validation-rule type="required" />
              <dx-pattern-rule
                :pattern="urlPattern"
                message="Enter a valid URL"
              />
            </dx-validator>
          </dx-text-box>
          <v-btn
            color="success"
            class="mt-4"
            @click="onSubmit">
            Create Quicklink
          </v-btn>
        </form>
      </v-card-text>
    </v-card>
  </v-dialog> -->

  <div>
    <b-modal
      v-model="dialog"
      centered
      size="md"
      button-size="sm"
      no-close-on-backdrop
    >
      <template #modal-header>
        <h5 class="modal-title">Add a Quicklink</h5>
        <button type="button" class="close" @click="close()">×</button>
      </template>
      <b-alert v-model="hasError" variant="danger" fade>
        {{ errorMessage }}
      </b-alert>
      <b-alert v-model="success" variant="success" fade>
        {{ successMessage }}
      </b-alert>
      <div class="accordion-box-quicklinks" v-if="quicklinks.length > 0">
        <div v-b-toggle.collapse-1>Current Quicklinks <i class="fas fa-chevron-down"></i></div>
        <b-collapse id="collapse-1">
          <div class="collapse-container pt-2">
            <div v-if="quicklinks.length">
              <div v-for="link in quicklinks" :key="link.field_001">
                <div><small>{{link.name}} ({{link.url}})</small><i class="fas fa-times removeQuicklink" @click="removeQuicklink(link.field_001)"></i></div>
              </div>
            </div>
            <div v-else>
              <small>No Quicklinks yet</small>
            </div>
          </div>
        </b-collapse>
      </div>

      <form @submit.prevent="onSubmit">
        <dx-text-box
          name="name"
          label-mode="floating"
          label="Name"
          v-model="form.name"
          class="mt-3"
        >
          <dx-validator>
            <dx-validation-rule type="required" />
          </dx-validator>
        </dx-text-box>
        <dx-text-box
          label-mode="floating"
          label="URL (e.g. https://venturelab.swiss)"
          v-model="form.url"
          class="mt-3"
        >
          <dx-validator>
            <dx-validation-rule type="required" />
            <dx-pattern-rule
              :pattern="urlPattern"
              message="Enter a valid URL"
            />
          </dx-validator>
        </dx-text-box>
        <dx-button
          text="Create Quicklink"
          type="success"
          class="mt-4"
          :use-submit-behavior="true" />
      </form>

      <template #modal-footer>
        <div class="w-100">
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  // import { ValidationObserver, ValidationProvider } from 'vee-validate'
  import DxValidator, { DxValidationRule, DxPatternRule } from 'devextreme-vue/validator'
  import DxButton from 'devextreme-vue/button'
  import { errorHandler } from '@/helpers/formHelper.js'
  import { DxTextBox } from 'devextreme-vue/text-box'

  const getInitialData = () => ({
    form: {
      name: null,
      url: null
    }
  })

  export default {
    name: 'save-searchquery',
    components: {
      // ValidationObserver,
      // ValidationProvider,
      DxTextBox,
      DxValidator,
      DxValidationRule,
      DxPatternRule,
      DxButton
    },
    data () {
      return {
        dialog: false,
        isSubmitting: false,
        hasError: false,
        errorMessage: '',
        success: false,
        successMessage: '',
        ...getInitialData(),
        urlPattern: '^(?!mailto:)(?:(?:http|https|ftp)://)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$' /* eslint-disable-line */
      }
    },
    created () {
    },
    methods: {
      onSubmit () {
        this.hasError = false
        const formData = this.form
        this.$store.dispatch('eventDashboard/CREATE_QUICKLINKS', formData).then(res => {
          const { errors } = res
          if (errors) {
            return errorHandler(this, errors)
          } else {
            this.success = true
            this.successMessage = 'Quicklink successfully added'
            this.$emit('added-quicklink')
            setTimeout(() => {
              this.success = false
              this.reset()
              this.dialog = false
            }, 2000)
          }
        }).catch(err => {
          this.hasError = true
          this.errorMessage = this.$t('formError.unknownwError')
          console.error(err)
          setTimeout(() => {
            this.hasError = false
          }, 3000)
        })
      },
      openModal () {
        this.dialog = true
      },
      close () {
        this.dialog = false
        this.isSubmitting = false
      },
      reset () {
        Object.assign(this.$data, getInitialData())
      },
      async removeQuicklink (itemToRemove) {
        this.hasError = false
        try {
          const { errors } = await this.$store.dispatch('eventDashboard/DELETE_QUICKLINK', itemToRemove)
          if (errors) throw errors
          this.success = true
          this.successMessage = 'Quicklink successfully deleted'
          this.$emit('added-quicklink')
          setTimeout(() => {
            this.success = false
          }, 3000)
        } catch (err) {
          this.hasError = true
          this.errorMessage = this.$t('formError.unknownwError')
          console.error(err)
        }
      }
    },
    computed: {
      ...mapGetters({ quicklinks: 'eventDashboard/QUICKLINKS' })
    }
  }
</script>
<style lang="scss" scoped>
.accordion-box-quicklinks {
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  padding: 0.5rem 0.5rem;
  margin: 1rem 0 2rem;
}

.removeQuicklink {
  cursor: pointer;
  margin-left: 1rem;
}
</style>
